import { useGetAggregatePrice } from '@/src/hooks';
import { GetAggregatePriceRequest } from 'xrpl';
import { Spinner, Text } from '@/src/ui-components';

type OraclePriceProps = Pick<GetAggregatePriceRequest, 'base_asset' | 'quote_asset' | 'oracles'>;

export const OraclePrice = ({ base_asset, quote_asset, oracles }: OraclePriceProps) => {
  const { data: aggregatePrice, isLoading } = useGetAggregatePrice({
    base_asset,
    quote_asset,
    oracles,
  });
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <Text as="span" weight="medium" className="font-mono">{aggregatePrice?.median ?? 'Price Not Found'}</Text>
      )}
    </>
  );
};
